import type { AnalyticsConsent } from './analyticsConsent'

export function optionalAnalyticsEnabled(
  consent: AnalyticsConsent | null | 'loading'
): consent is 'granted' {
  return consent === 'granted'
}

/**
 * One shared send boundary for every nonessential analytics sink. Keeping the
 * decision outside provider-specific code makes it difficult to accidentally
 * add a new sink that bypasses the user's choice.
 */
export function runAnalyticsSinksIfConsented(
  consent: AnalyticsConsent | null,
  sinks: ReadonlyArray<() => void>
): boolean {
  if (!optionalAnalyticsEnabled(consent)) return false

  for (const send of sinks) {
    try {
      send()
    } catch {
      // Analytics must never interfere with the product experience, and one
      // unavailable provider must not prevent another consented provider.
    }
  }
  return true
}
